import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  table: {
    background: theme.colorPalette.beige_25,
    marginBottom: 10
  },
  bigTable: {
    boxShadow: 'none',
    marginTop: 32
  },
  tableHeading: {
    paddingRight: 0,
    paddingLeft: 0,
    fontSize: 10,
    textTransform: 'uppercase',
    paddingBottom: 14,
    paddingTop: 27,
    '&:first-child': {
      paddingLeft: 24
    }
  },
  bigTableHeading: {
    composes: '$tableHeading',
    paddingBottom: 8,
    paddingTop: 0,
    // Match the body cells' right padding so column headers aren't cramped together.
    paddingRight: 32,
    '&:first-child': {
      paddingLeft: 32
    }
  },
  tableHeader: {
    height: 'auto'
  },
  icon: {
    left: -30,
    width: 20,
    height: 20
  },
  tableCell: {
    paddingRight: 0,
    paddingLeft: 0,
    maxWidth: 160,
    color: theme.colorPalette.green_90,
    verticalAlign: 'top',
    paddingTop: 16,
    paddingBottom: 26,
    '&:first-child': {
      paddingLeft: 24
    }
  },
  bigTableCell: {
    composes: '$tableCell',
    padding: '16px 32px 16px 0',
    '&:first-child': {
      paddingLeft: 32
    }
  },
  borderlessCell: {
    borderBottom: 'none',
    paddingBottom: 0
  },
  borderlessRow: {
    height: 'auto'
  },
  dateRow: {
    padding: '12px 0 12px 32px',
    fontSize: '10px !important',
    color: theme.colorPalette.green_75,
    textTransform: 'uppercase'
  },
  paginationCaption: {
    color: theme.colorPalette.green_90,
    fontWeight: 500
  },
  dateInfo: {
    display: 'inline-block'
  },
  fullCell: {
    width: '100%'
  },
  internalNotes: {
    color: theme.colorPalette.green_75
  },
  backdrop: {
    backgroundColor: `${theme.colorPalette.green_90}d9` // 'd9' is the alpha value
  },
  dialogRoot: {
    '@media(max-width: 560px)': {
      padding: '0px !important'
    }
  },
  dialogPaper: {
    width: '100%',
    maxWidth: 1300,
    backgroundColor: theme.colorPalette.beige_25,
    borderRadius: theme.sizes.roundCorners,
    boxShadow: '0 2px 2px 0 #0000003d, 0 0 2px 0 #0000001e',
    flexDirection: 'column',
    overflowY: 'auto',
    minHeight: 560
  },
  scrollPaper: {
    alignItems: 'flex-start'
  },
  tableContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  dialogHeader: {
    display: 'flex',
    flexShrink: 0,
    justifyContent: 'flex-end'
  },
  dialogCloseButton: {
    boxSizing: 'content-box',
    height: 48,
    width: 48,
    padding: 0,
    margin: '8px 10px 0'
  },
  dialogCloseButtonIcon: {
    height: 48,
    width: 48
  },
  dialogTitleContainer: {
    marginLeft: 48,
    marginRight: 48,
    lineHeight: 1,
    '@media(max-width: 560px)': {
      marginLeft: 24,
      marginRight: 24
    }
  },
  dialogTitle: {
    fontSize: 42,
    fontWeight: 100,
    color: theme.colorPalette.green_75,
    '@media(max-width: 560px)': {
      fontSize: 24,
      fontWeight: 300
    }
  },
  dialogSubtitle: {
    fontSize: 20,
    fontWeight: 100,
    color: theme.colorPalette.green_75,
    '@media(max-width: 560px)': {
      fontSize: 24,
      fontWeight: 300
    }
  },
  emptyState: {
    fontStyle: 'italic'
  },
  options: {
    padding: theme.spacing(3, 0)
  },
  loadingContainer: {
    margin: theme.spacing(4, 0),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  loadingIcon: {
    marginBottom: theme.spacing(4)
  },
  loadingText: {
    padding: theme.spacing(4, 0)
  }
});

export default styles;
export const useStyles = makeStyles(styles);

// Per-row Compare + Revert icon-button actions (version-actions.jsx).
export const useActionStyles = makeStyles((theme) => ({
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  iconButton: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
    height: 40,
    padding: theme.spacing(1),
    borderRadius: theme.sizes.roundCorners,
    boxSizing: 'border-box'
  },
  icon: {
    width: 24,
    height: 24,
    display: 'block'
  },
  // The icon SVGs bake in the orange accent; gray them out for disabled actions in place.
  iconDisabled: {
    filter: 'grayscale(1)',
    opacity: 0.4
  },
  tooltip: {
    backgroundColor: theme.colors.tooltip_background
  }
}));
